import ConversionTypes from "./ConversionTypes";

const ConversionExamples = {
    [ConversionTypes.CostPer100g]: "For instance, knowing how much per 100g of rice costs when buying a bulk packet",
    [ConversionTypes.CostPer100ml]: "For instance, knowing how much per 100ml of juice costs when buying a large juice bottle",
    [ConversionTypes.CostPer1l]: "For instance, knowing how much per litre of milk costs when buying a large milk bottle",
    [ConversionTypes.CostPerUnit]: "For instance, knowing how much does the price of an egg costs when buying a carton."
};

export default ConversionExamples;